import { useContext, useMemo } from "react";
import DataClientContext from "./DataClientContext";
export default function useInteroperabilityLayer() {
    const dataClient = useContext(DataClientContext);
    const interoperabilityLayer = useMemo(()=>{
        if (!('graphQlDataClient' in dataClient) || !dataClient.graphQlDataClient) {
            return null;
        }
        return dataClient.graphQlDataClient.interoperabilityLayer;
    }, [
        dataClient
    ]);
    return interoperabilityLayer;
}

//# sourceMappingURL=useInteroperabilityLayer.js.map